import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVisit } from './visitTracker';

const RouteAnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const timer = window.setTimeout(() => {
            trackVisit(`${location.pathname}${location.search}`);
        }, 0);
        return () => window.clearTimeout(timer);
    }, [location.pathname, location.search]);

    return null;
};

export default RouteAnalyticsTracker;
